import React, { useEffect, useRef, useState } from 'react';
import './Select.scss';

const Select = (props) => {
  const {
    label,
    placeholder = 'Select',
    value,
    onChange,
    items,
    className,
    disabled = false,
  } = props;
  const selectRef = useRef();

  const [open, setOpen] = useState(false);

  const handleClickAaway = (e) => {
    if (
      selectRef &&
      selectRef.current &&
      !selectRef.current.contains(e.target)
    ) {
      setOpen(false);
    }
  };

  const handleSelect = (option, label) => {
    onChange(option, label);
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickAaway);

    return () => {
      document.removeEventListener('mousedown', handleClickAaway);
    };
  }, [selectRef]);

  return (
    <div ref={selectRef} className="select_wrapper">
      <div className="select_header">
        {label && <label>{label}</label>}

        <div className={`select_btn_wrapper ${className ? className : ''}`}>
          <button
            disabled={disabled}
            onClick={() => setOpen((prev) => !prev)}
            type="button"
          >
            <span
              className={`${!value || (value && (!value.value || !value.label)) ? 'no_value' : ''}`}
            >
              {value ? value.label || value.value || placeholder : placeholder}
            </span>

            <svg
              className={`arrow_down ${open ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className={`select_dropdown ${open ? 'active' : ''}`}>
        <ul>
          {items &&
            items.length > 0 &&
            items.map((item, index) => {
              return (
                <li
                  className={!item.value ? 'default_li' : ''}
                  onClick={() => handleSelect(item.value, item.label)}
                  key={index}
                >
                  <span>{item.label}</span>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default Select;
